import React, {useState, useEffect} from 'react';

import globals from '../../globals.json';
import Popup from '../partials/OLIPopup.js';
import AudioControls from '../UI/AudioPlayer.js'

const ClickReveal = props => {
  const [isRevealed, setIsRevealed] = useState(props.data.clickers.map(() => false));
  const [hasBeenRevealed, setHasBeenRevealed] = useState(props.data.clickers.map(() => false));
  const [revealedIndex, setRevealedIndex] = useState(-1);
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    props.audioController.playAudioByName(props.data.intro.audio);
    return () => {
      //audio cleanup
      if (revealedIndex > -1) {
        props.audioController.removeAudio(props.data.clickers[revealedIndex].reveal.audio)
      } else if (showIntro) {
        props.audioController.removeAudio(props.data.intro.audio)
      }
    }
  }, [])

  const handleClick = (i) => {
    setRevealedIndex(-1);
    props.audioController.removeAudio(props.data.clickers[i].reveal.audio)
  };

  const handleIntroClick = () => {
    props.audioController.removeAudio(props.data.intro.audio);
    setShowIntro(false);
  }

  const revealItem = (i) => {
    props.audioController.playAudioByName(props.data.clickers[i].reveal.audio)
    let temp = isRevealed.map(el => el);
    temp[i] = true;
    setIsRevealed(temp);

    let temp2 = hasBeenRevealed.map(el => el);
    temp2[i] = true;
    setHasBeenRevealed(temp2);
    setRevealedIndex(i);
  };

  const isComplete = () => {
    if (props.data.gated === false) return true;
    //there are no falses in the isRevealed array
    return 0 === hasBeenRevealed.filter(el => !el).length;
  };

  return (
    <div className="ClickReveal">
      <AudioControls audioCollection={props.audioCollection} audioController={props.audioController} />
      <div className="clickers">
        {
          props.data.clickers.map((el, i) => {
            return <div className={`clicker ${el.class} ${hasBeenRevealed[i] ? 'complete' : ''}`} key={`clicker-${i}`} onClick={() => revealItem(i)}>{el.text}</div>
          })
        }
      </div>
      <div className="reveals">
        {
          revealedIndex > -1 && (
            <Popup data={props.data.clickers[revealedIndex].reveal} onComplete={() => handleClick(revealedIndex)} />
          )
        }
        {
          showIntro && (
            <Popup data={props.data.intro} onComplete={handleIntroClick} />
          )
        }
      </div>
      <div className={`truck-interior`} />
      <div className="button" onClick={props.onComplete}>{globals.continueButtonText}</div>
    </div>
  )
}

export default ClickReveal